// Module
var code = "<span class=\"more-info-tooltip implioicons-question-mark-filled\" data-toggle=\"popover\" data-placement=\"bottom\"> </span> ";
// Exports
module.exports = code;